import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  Fragment,
} from "react";
import ReactFlow, {
  Background,
  ControlButton,
  Controls,
  MiniMap,
  ReactFlowProvider,
  useEdgesState,
  useNodesState,
} from "react-flow-renderer";
import {
  useAction,
  useActions,
  useActiveBlock,
  useProgram,
  useProgramDone,
} from "../../../Api/newSockets.api";
import ProgramSidebar from "../Program/ProgramSidebar";
import ActionSidebar from "./ActionSidebar";
import { ReactComponent as PlayIcon } from "../../../assets/icons/play.svg";
import { ReactComponent as PauseIcon } from "../../../assets/icons/pause.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import MonacoEditor from "@monaco-editor/react";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import useUndoableState from "../../../hooks/useUndoableState";
import useUndoRedo from "../../../hooks/useUndoableState";
import { savePathToLocalStorage } from "../../../utils/helpers";
import useCheckMobileScreen from "../../../hooks/useCheckScreen";
import DesktopOnlyMessage from "../../../components/DesktopOnlyMessage/DesktopOnlyMessage";

type ActionEditorProps = {
  match?: any;
  actionId?: any;
  readMode?: boolean;
};

const BgColor = "#1b2023";

const ActionEditor = (props: ActionEditorProps) => {
  savePathToLocalStorage();

  const { actions } = useActions();
  const { updateAction, getAction, connected } = useAction();
  const currentUserDevice = useCheckMobileScreen();
  // const { getProgram, updateProgram, runProgram, stopProgram } = useProgram();
  // const { program } = getProgram(
  //   parseInt(props.match?.params?.id) || props.programId
  // );
  const actionId = parseInt(props.match?.params?.id);
  const [running, setRunning] = useState(false);
  const [actionRow, setActionRow] = useState<any>();
  const [code, setCode] = useState();
  const [test, setTest] = useState("var a = 5");

  const data = useRef();

  useEffect(() => {
    var data = getAction(actionId).then((data: any) => {
      setActionRow(data);
      setCode(data.code);
    });
  }, [connected]);
  console.log(actionRow);

  const options = {
    selectOnLineNumbers: true,
    autoDetectHighContrast: true,
  };

  const handleChange = (newValue, e) => {
    console.log(newValue);
    setCode(newValue);
    setState(newValue);
  };

  const handleSave = () => {
    const action = {
      id: actionId,
      code: code,
    };
    updateAction(action);
    toast.success("Saved");
  };

  // const onRunProgram = () => {
  //   if (running == false) {
  //     setRunning(true);
  //   } else {
  //     console.log("");
  //   }
  // };

  // const onStopProgram = () => {
  //   if (running == true) {
  //     setRunning(false);
  //   } else {
  //     console.log("");
  //   }
  // };

  const {
    state,
    setState,
    undo,
    redo,
    isUndoPossible,
    isRedoPossible,
    pastStates,
    futureStates,
  } = useUndoRedo(test);

  return (
    <Fragment>
      {currentUserDevice ? (
        <DesktopOnlyMessage />
      ) : (
        <div className="action-editor">
          <ActionSidebar
            onSave={handleSave}
            action={actionRow ? actionRow : ""}
            code={code}
            undo={() => undo()}
            redo={() => redo()}
          />
          <div id="codeeditor-wrapper">
            <MonacoEditor
              defaultLanguage="javascript"
              theme="vs-dark"
              value={code}
              options={options}
              onChange={handleChange}
              loading="Loading..."
              height="100vh"
            />
          </div>
        </div>
      )}

      <ToastContainer
        autoClose={5000}
        position="bottom-right"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Fragment>
  );
};

export default ActionEditor;
